import { useApiClient } from "@/modules/api/apiClient.store.ts";
import { parseCoingatePaymentResult } from "@/modules/billing/coingate/parseCoingatePaymentResult.ts";
import type { PaymentParams, PaymentProps } from "@/modules/billing/payment/PaymentParams";
import {
    getRedirectUrlFromData,
    linkSendData,
    persistentDataRequest,
    redirectToGatewayAndWaitForResponse,
} from "@/modules/billing/payment/paymentUtils.ts";
import { t_StartingPayment } from "@/modules/billing/progressLabels.tsx";
import { useUnmountSignal } from "@/utils/react/useUnmountSignal.tsx";
import type { CoingateConfig, CoingateRedirectSendDataResponse, MethodConfig } from "@warrenio/api-spec/spec.oats.gen";
import { useImperativeHandle } from "react";

export default function CoingatePaymentForm({
    actionsRef,
    method: { key },
}: {
    config: CoingateConfig;
    method: MethodConfig;
} & PaymentProps) {
    //#region Hooks

    const apiClient = useApiClient();
    const signal = useUnmountSignal();

    useImperativeHandle(actionsRef, () => ({
        needsPopUp(_params) {
            return true;
        },

        async makePayment(params: PaymentParams) {
            const { progress, popup, account } = params;

            progress(t_StartingPayment);
            const { data } = await linkSendData<CoingateRedirectSendDataResponse>(apiClient, params, "coingate", {
                paymentMethod: key,
            });

            const { persistent_data_ref } = data;

            return await redirectToGatewayAndWaitForResponse({
                popup,
                progress,
                redirectUrl: getRedirectUrlFromData(data),
                signal,
                check: async () =>
                    parseCoingatePaymentResult(
                        await persistentDataRequest(apiClient, account.id, persistent_data_ref, signal),
                    ) != null,
            });
        },
    }));
    //#endregion

    return null;
}
